import { LocaleEnum, LocalePrefixEnum } from "@/enums";
import type { I18nLocale, I18nLocalePrefix } from "@/types";

export const EXCLUDED_I18N_PATHS = ["/auth"];

export const LOCALE_COOKIE_NAME: string = "locale";
export const TIMEZONE_COOKIE_NAME: string = "tz";

export const DEFAULT_LOCALE: I18nLocale = LocaleEnum.EN;
export const LOCALES: I18nLocale[] = [
  LocaleEnum.EN,
  LocaleEnum.DE,
  LocaleEnum.TH,
];
export const LOCALE_PREFIX: I18nLocalePrefix = LocalePrefixEnum.AS_NEEDED;

export const DEFAULT_TIMEZONE: string = "UTC";
